import { createApp } from "vue";

import { getFileFromUrl } from "common/utils/file";
import ScrollToElement from "common/utils/ui/scroll-to-element";
import { getQueryParams, removeQueryParam } from "common/utils/browser";
import store from "./store/store";
import i18n from "../vue-cart/vue-i18n";
import defaultSurfaces from "./misc/default-surfaces";
import ProductDetailsPrint from "./ProductDetailsPrint.vue";
import { SURFACES } from "./misc/constants";

const initAutoUpload = async () => {
  const { artwork_urls: imageUrls, file_content_type: imageType } = getQueryParams();
  if (!imageUrls || !imageType) return;

  removeQueryParam("artwork_urls");
  removeQueryParam("file_content_type");

  const imageUrl = Object.values(JSON.parse(imageUrls)).pop();
  const [file] = await Promise.all([
    getFileFromUrl(imageUrl, `artwork_image-${Date.now()}`, imageType),
    store.dispatch("artwork_front/removeArtwork")
  ]);
  store.dispatch("artwork_front/upload", file);
  ScrollToElement.scrollIntoViewBySelector("#vue-product-details-print");
};

export const initDefaultProps = () => {
  store.commit("product/setDefaultData", window.jiffy_made_product_props);
  store.dispatch("creation/fetchAreas");
  store.dispatch("product/fetchProduct");
  store.commit("setConfig", window.jiffy_made_config);

  store.commit("surface_front/setDefaultSurface", defaultSurfaces.front);
  store.commit("surface_back/setDefaultSurface", defaultSurfaces.back);
  store.commit("surface_front/setSurfaceLabel", SURFACES.FRONT);
  store.commit("surface_back/setSurfaceLabel", SURFACES.BACK);

  store.dispatch("artwork_front/createDtfChannel");
  store.dispatch("artwork_back/createDtfChannel");
};

const initPageData = () => {
  const activeColor = document.getElementById("active-color-name")?.value;
  const activeCompositionId = document.querySelector(
    `.js-color-variant-selector[data-color="${activeColor}"]`
  )?.dataset?.compositionId;

  if (activeColor && activeCompositionId) {
    store.dispatch("app/setActiveComposition", {
      compositionId: activeCompositionId,
      color: activeColor
    });
  }
};

const initProductDetailsPrint = () => {
  const $wrapper = document.getElementById("vue-product-details-print");

  if (!$wrapper) return;

  const ProductDetailsPrintWrapper = createApp({});

  ProductDetailsPrintWrapper.component("ProductDetailsPrint", ProductDetailsPrint);
  ProductDetailsPrintWrapper.use(store);
  ProductDetailsPrintWrapper.use(i18n);

  initDefaultProps();
  initPageData();
  initAutoUpload();
  ProductDetailsPrintWrapper.mount("#vue-product-details-print");
};

export default initProductDetailsPrint;
